import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import axios from "axios";
import Select from "react-select";
import Loader from "../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import "./CreateClient.css"
import moment from "moment";
const CreateClient = () => {
    const navigate = useNavigate();
    const currentDate = new Date().toISOString().split("T")[0];
    const [errorFirstName, setErrorFirstName] = useState(false);
    const [errorClientEmail, setErrorClientEmail] = useState(false);
    const [errorClientMobile, setErrorClientMobile] = useState(false);
    const [errorProjectName, setErrorProjectName] = useState(false);
    const [errorClientId, setErrorClientId] = useState(false);
    const [dummy, setDummy] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    const [loading, setLoading] = useState(false);
    const LoginToken = GetToken();


    const [profileAlldata, setProfileAllData] = useState({
        clientName: "",
        clientEmail: "",
        clientMobile: "",

        projectName: "",
        clientId: "",
        startDate: "",
        endDate: "" 
    });
    // const newId = profileAlldata?.clientId ;
console.log(profileAlldata,"profileAlldata");
    const [clientDetails, setClientDetails] = useState();
    console.log(clientDetails,"clientDetailsclientDetails");
    const [projectId, setProjectId] = useState([]);
    const [getAllUser, setGetAllUser] = useState([]);

    const location =useLocation()
const PrefiledData = location?.state;
console.log(PrefiledData,"PrefiledData");
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    function isValidEmail(clientEmail) {
        return emailRegex.test(clientEmail);
    }
  
    useEffect(() => {
        if (PrefiledData) {
          setProfileAllData((prevProfileAllData) => ({
              ...prevProfileAllData,
              clientName: PrefiledData?.item?.ClientName,
              clientEmail:PrefiledData?.item?.Email,
              clientMobile:PrefiledData?.item?.Phone,

              projectName:PrefiledData?.item?.ProjectName,
              clientId:PrefiledData?.item?.ClientId,
            // clientId:PrefiledData?.item?.Client?.ClientName,
              startDate:PrefiledData?.item?.StartDate,
              endDate:PrefiledData?.item?.EndDate
              
          }));
        }
      }, [PrefiledData]);
    const validate = () => {
        if (!profileAlldata?.clientName) {
            setErrorFirstName("userFirstName");
            return false;
        }
        if (!profileAlldata?.clientEmail) {
            setErrorClientEmail("userClientEmail");
            return false;
        }

        if (!isValidEmail(profileAlldata?.clientEmail)) {
            toast.error("Please enter valid email");
            return false;
        }
        if (!profileAlldata?.clientMobile) {
            setErrorClientMobile("userClientMobile");
            return false;
        }   
        return true;
    };

    const projectValidate = () => {
        if (!profileAlldata?.projectName) {
            setErrorFirstName("userFirstName");
            return false;
        }

        return true;
    };

    // POST API'S 
    const handleSaveClient = () => {
        if (!validate()) return;
        const data = {};
        data.ClientName = profileAlldata.clientName;
        data.Email = profileAlldata.clientEmail;
        data.Phone = profileAlldata.clientMobile;

        setLoading(true);
        const option = {
            method: "POST", 
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Client/SaveClient`,
            data: { data: JSON.stringify(data) },
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    toast.success(e?.data?.message);
                }               
                setProfileAllData({
                    clientName: "",
                    clientEmail: "",
                    clientMobile: "",

                });
                setErrorFirstName("")
                setErrorClientEmail("")
                setErrorClientMobile("")
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const handleSaveProject = () => {
        if (!projectValidate()) return;
        const data = {};
        if (PrefiledData) {
            data.ProjectId = PrefiledData?.item?.ProjectId
        }
        data.ProjectName = profileAlldata.projectName;
        data.ClientId = profileAlldata.clientId;
        data.StartDate = profileAlldata.startDate;
        data.EndDate = profileAlldata.endDate;

        setLoading(true);
        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Projects/SaveProject`,
            data: { data: JSON.stringify(data) },
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                if (e?.status === 200) {
                    toast.success(e?.data?.message);
                }
                setProfileAllData({
                    projectName: "",
                    clientId: "",
                    startDate: "",
                    endDate: "",

                });
                setErrorFirstName("")
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    // GET API'S 
    const GetAllClients = () => {
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Client/GetAllClients`,
        };
        axios(option)
            .then((e) => {
                const clientdata = JSON.parse(e?.data?.data)
                
                const clientId = clientdata?.Result;
                console.log(clientId,"wedfwedfcwedfc");
                const clientNameId = clientId?.map((item) => ({
                    label: item,
                    value: item,
                }));
                console.log(clientNameId,"clientNameId");
                setClientDetails(clientNameId);

            })
            .catch(() => { });
    };

    const GetAllUser = () => {
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Recas/GetAllUsers`,
        };
        axios(option)
            .then((e) => {
                const allData = JSON.parse(e?.data?.data)
                const ReportId = allData?.Result;
                const ReportTold = ReportId?.map((item) => ({
                    label: item,
                    value: item,
                }));
                setGetAllUser(ReportTold);

            })
            .catch(() => { });
    };

    const GetProfile = () => {
        setLoading(true);
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Projects/GetAllProjects`,
        };
        axios(option)
            .then((e) => {

                const data = JSON.parse(e?.data?.data);
                const ProjectId = data?.map((item) => ({
                    label: item?.ProjectId,
                    value: item?.ProjectId,
                }));
                setProjectId(ProjectId)
                setLoading(false);
            })
            .catch((error) => {
                if (
                    error?.message === "Network Error" &&
                    error?.code === "ERR_NETWORK"
                ) {
                    toast.error("Your Session has been expired");
                    RemoveUserSession();
                    navigate("/");
                }
            });
    };

    useEffect(() => {
        GetProfile();
        GetAllUser();
        GetAllClients();

    }, []);

    const handleProjectCancel = () => {
        setProfileAllData({
            projectName: "",
            clientId: "",
            startDate: "",
            endDate: "",
        })
        setErrorFirstName("");
    }
    const handleClientCancel = () => {
        setProfileAllData({
            clientName: "",
            clientEmail: "",
            clientMobile: "",

        })
    }

    useEffect(() => {
        if (window.innerWidth < 600) {
            const timeoutId = setTimeout(() => {
                setShowSidebar(false);
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
        setShowSidebar(true);
    }, []);

    return (
        <>
            {loading ? <Loader /> : null}
            <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="d-flex">
                <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
                <section
                    className={
                        showSidebar
                            ? "EMP-profile-main-section"
                            : "EMP-profile-main-section-new"
                    }
                >
                    <div className="EMP-profile-all-icons">
                        <div>
                            <p className="MAIN-HEADING"> Client </p>
                        </div>
                        <div className="dashboiard-inner-header">
                            <BiHomeAlt className="EMP-home-icon-header-inn" />
                            <MdKeyboardArrowRight />
                            <p> Client</p>
                            <MdKeyboardArrowRight />
                            <p> Create</p>
                        </div>
                    </div>
                    <div className="EMP-profile-main-container">
                        <div className="EMP-profile-outter-container">
                            <div className="EMP-profile-inner-container">
                                {/* <div className="EMP-profile-heading">
                                    <p> Client</p>
                                </div> */}
{PrefiledData ? (

                                <Tabs
                                    // defaultActiveKey="profile"
                                    defaultActiveKey={PrefiledData && PrefiledData.tab === "project" ? "home" : "profile"}

                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                >

                                    {/* Create client start  */}
                                    {PrefiledData && PrefiledData.tab === "client" && (

                                        <Tab eventKey="profile" title="Update Client" className="EMP-profile-inner-box-new">
                                        <div className="EMP-profile-inner-box row">
                                            {/* Name Field   */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Name*"
                                                    value={profileAlldata?.clientName}
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientName: e?.target?.value,   
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorFirstName("userFirstName");
                                                        } else {
                                                            setErrorFirstName("false");
                                                        }
                                                    }}  
                                                />
                                                {errorFirstName === "userFirstName" &&
                                                    !profileAlldata?.clientName ? (
                                                    <span className="contact_error-dob">
                                                        Name is required.
                                                    </span>
                                                ) : null}
                                            </div>
                                            {/* Email  */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    value={profileAlldata?.clientEmail}
                                                    label="Email*"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientEmail: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientEmail("userClientEmail");
                                                        } else {
                                                            setErrorClientEmail("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientEmail === "userClientEmail" &&
                                                    !profileAlldata?.clientEmail ? (
                                                    <span className="contact_error-dob">
                                                        Email is required.
                                                    </span>
                                                ) : null}
                                            </div>

                                            {/* Phone  */}

                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Mobile*"
                                                    maxLength="10"
                                                    value={profileAlldata.clientMobile}
                                                    onChange={(e) => {
                                                        const inputMobile = e.target.value
                                                            .replace(/\D/g, "")
                                                            .slice(0, 10);
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientMobile: inputMobile,
                                                        });
                                                    }}
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientMobile("userClientMobile");
                                                        } else {
                                                            setErrorClientMobile("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientMobile === "userClientMobile" &&
                                                    !profileAlldata?.clientMobile ? (
                                                    <span className="contact_error-dob">
                                                        Phone is required.
                                                    </span>
                                                ) : null}
                                            </div>

                                            {/* 
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Phone*"
                                                    type="Mobile"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientMobile: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientMobile("userClientMobile");
                                                        } else {
                                                            setErrorClientMobile("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientMobile === "userClientMobile" &&
                                                    !profileAlldata?.clientMobile ? (
                                                    <span className="contact_error-dob">
                                                        Phone is required.
                                                    </span>
                                                ) : null}
                                            </div> */}



                                            <div className="Addemployee-buttons">
                                                <button
                                                    className="Profile-submit-button"
                                                    onClick={() => handleSaveClient("update")}>
                                                        {PrefiledData?  "Update" :"Submit"}
                                                    {/* Submit */}
                                                </button>
                                                <button className="Profile-Cancel-button"
                                                    onClick={() => handleClientCancel()}
                                                > Cancel </button>
                                            </div>
                                        </div>
                                    </Tab>

)}

                                    {/* Create Project Start  */}
                                    {PrefiledData && PrefiledData.tab === "project" && (
 
                                    <Tab eventKey="home" title="Update Project" className="EMP-profile-inner-box-new">
                                        <div className="EMP-profile-inner-box row">
                                            {/* Name Field   */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    value={profileAlldata?.projectName}
                                                    label="Project Name*"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            projectName: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorProjectName("userProjectName");
                                                        } else {
                                                            setErrorProjectName("false");
                                                        }
                                                    }}
                                                />
                                                {errorProjectName === "userProjectName" &&
                                                    !profileAlldata?.projectName ? (
                                                    <span className="contact_error-dob">
                                                        Project Name is required.
                                                    </span>
                                                ) : null}
                                            </div>


                                            {/* Client id   */}
                                            <div className="profile-inputs col-6 ">
                                                <Select
                                                    classNamePrefix="Create_Client-dropdown"
                                                    placeholder="Client Name"
                                                    // value={profileAlldata.clientId}
                                                    value={profileAlldata?.clientId ? clientDetails?.find((item) => item.label.Id === profileAlldata.clientId) : null } 
                                                    options={clientDetails}
                                                    getOptionLabel={(options) => options?.label?.ClientName}
                                                    getOptionValue={(options) => options?.value?.Id}
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientId: e?.value?.Id, 
                                                        })
                                                    }
                                                />
                                            </div>

                                            {/* Start date  */}
                                            <div className="EMP-flash-floating-sheet col-6">
                                                <label htmlFor=""> Choose start date </label>
                                                <input
                                                    type="date"
                                                    // value={profileAlldata?.startDate}
                                                    value={moment(profileAlldata?.startDate).format("YYYY-MM-DD")} 
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            startDate: e?.target?.value,
                                                        })
                                                    }
                                                    max={currentDate}
                                                />
                                            </div>

                                            {/* end date  */}
                                            <div className="col-6">
                                                <div className="flash-floating-sheet col">
                                                    <label htmlFor=""> Choose end date </label>
                                                    <input
                                                        type="date"
                                                        name=""
                                                        id=""
                                                        //   value={profileAlldata?.endDate}
                                                        value={moment(profileAlldata?.endDate).format("YYYY-MM-DD")} 
                                                        onChange={(e) =>
                                                            setProfileAllData({
                                                                ...profileAlldata,
                                                                endDate: e?.target?.value,
                                                            })
                                                        }
                                                        max={currentDate}
                                                    />
                                                </div>
                                            </div>

                                            <div className="Addemployee-buttons">
                                                <button
                                                    className="Profile-submit-button"
                                                    onClick={() => handleSaveProject("update")}>
                                                  {PrefiledData?  "Update" :"Submit"}
                                                </button>
                                                <button className="Profile-Cancel-button"
                                                    onClick={() => handleProjectCancel()}
                                                > Cancel </button>
                                            </div>
                                        </div>
                                    </Tab>
                                    )}
                                </Tabs>
                                ) : (
                                    <div>
                                        
                                <Tabs
                                    // defaultActiveKey="profile"
                                    defaultActiveKey={PrefiledData && PrefiledData.tab === "project" ? "home" : "profile"}

                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                >


                                        <Tab eventKey="profile" title="Create Client" className="EMP-profile-inner-box-new">
                                        <div className="EMP-profile-inner-box row">
                                            {/* Name Field   */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Name*"
                                                    value={profileAlldata?.clientName}
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientName: e?.target?.value,   
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorFirstName("userFirstName");
                                                        } else {
                                                            setErrorFirstName("false");
                                                        }
                                                    }}  
                                                />
                                                {errorFirstName === "userFirstName" &&
                                                    !profileAlldata?.clientName ? (
                                                    <span className="contact_error-dob">
                                                        Name is required.
                                                    </span>
                                                ) : null}
                                            </div>
                                            {/* Email  */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    value={profileAlldata?.clientEmail}
                                                    label="Email*"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientEmail: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientEmail("userClientEmail");
                                                        } else {
                                                            setErrorClientEmail("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientEmail === "userClientEmail" &&
                                                    !profileAlldata?.clientEmail ? (
                                                    <span className="contact_error-dob">
                                                        Email is required.
                                                    </span>
                                                ) : null}
                                            </div>

                                            {/* Phone  */}

                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Mobile*"
                                                    maxLength="10"
                                                    value={profileAlldata.clientMobile}
                                                    onChange={(e) => {
                                                        const inputMobile = e.target.value
                                                            .replace(/\D/g, "")
                                                            .slice(0, 10);
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientMobile: inputMobile,
                                                        });
                                                    }}
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientMobile("userClientMobile");
                                                        } else {
                                                            setErrorClientMobile("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientMobile === "userClientMobile" &&
                                                    !profileAlldata?.clientMobile ? (
                                                    <span className="contact_error-dob">
                                                        Phone is required.
                                                    </span>
                                                ) : null}
                                            </div>

                                            {/* 
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    label="Phone*"
                                                    type="Mobile"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientMobile: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorClientMobile("userClientMobile");
                                                        } else {
                                                            setErrorClientMobile("false");
                                                        }
                                                    }}
                                                />
                                                {errorClientMobile === "userClientMobile" &&
                                                    !profileAlldata?.clientMobile ? (
                                                    <span className="contact_error-dob">
                                                        Phone is required.
                                                    </span>
                                                ) : null}
                                            </div> */}



                                            <div className="Addemployee-buttons">
                                                <button
                                                    className="Profile-submit-button"
                                                    onClick={() => handleSaveClient("update")}>
                                                        {PrefiledData?  "Update" :"Submit"}
                                                    {/* Submit */}
                                                </button>
                                                <button className="Profile-Cancel-button"
                                                    onClick={() => handleClientCancel()}
                                                > Cancel </button>
                                            </div>
                                        </div>
                                    </Tab>



 
                                    <Tab eventKey="home" title="Create Project" className="EMP-profile-inner-box-new">
                                        <div className="EMP-profile-inner-box row">
                                            {/* Name Field   */}
                                            <div className="profile-inputs col-6">
                                                <FloatingLabelInput
                                                    value={profileAlldata?.projectName}
                                                    label="Project Name*"
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            projectName: e?.target?.value,
                                                        })
                                                    }
                                                    onBlur={(e) => {
                                                        if (!e?.target?.value) {
                                                            setErrorProjectName("userProjectName");
                                                        } else {
                                                            setErrorProjectName("false");
                                                        }
                                                    }}
                                                />
                                                {errorProjectName === "userProjectName" &&
                                                    !profileAlldata?.projectName ? (
                                                    <span className="contact_error-dob">
                                                        Project Name is required.
                                                    </span>
                                                ) : null}
                                            </div>


                                            {/* Client id   */}
                                            <div className="profile-inputs col-6 ">
                                                <Select
                                                    classNamePrefix="Create_Client-dropdown"
                                                    placeholder="Client Name"
                                                    value={profileAlldata?.clientId? clientDetails?.Id : null}
                                                    options={clientDetails}
                                                    getOptionLabel={(options) => options?.label?.ClientName}
                                                    getOptionValue={(options) => options?.value?.Id}
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            clientId: e?.value?.Id,
                                                        })
                                                    }
                                                />
                                            </div>

                                            {/* Start date  */}
                                            <div className="EMP-flash-floating-sheet col-6">
                                                <label htmlFor=""> Choose start date </label>
                                                <input
                                                    type="date"
                                                    // value={profileAlldata?.startDate}
                                                    value={moment(profileAlldata?.startDate).format("YYYY-MM-DD")} 
                                                    onChange={(e) =>
                                                        setProfileAllData({
                                                            ...profileAlldata,
                                                            startDate: e?.target?.value,
                                                        })
                                                    }
                                                    max={currentDate}
                                                />
                                            </div>

                                            {/* end date  */}
                                            <div className="col-6">
                                                <div className="flash-floating-sheet col">
                                                    <label htmlFor=""> Choose end date </label>
                                                    <input
                                                        type="date"
                                                        name=""
                                                        id=""
                                                        //   value={profileAlldata?.endDate}
                                                        value={moment(profileAlldata?.endDate).format("YYYY-MM-DD")} 
                                                        onChange={(e) =>
                                                            setProfileAllData({
                                                                ...profileAlldata,
                                                                endDate: e?.target?.value,
                                                            })
                                                        }
                                                        max={currentDate}
                                                    />
                                                </div>
                                            </div>

                                            <div className="Addemployee-buttons">
                                                <button
                                                    className="Profile-submit-button"
                                                    onClick={() => handleSaveProject("update")}>
                                                  {PrefiledData?  "Update" :"Submit"}
                                                </button>
                                                <button className="Profile-Cancel-button"
                                                    onClick={() => handleProjectCancel()}
                                                > Cancel </button>
                                            </div>
                                        </div>
                                    </Tab>
                       
                                </Tabs>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};
export default CreateClient;
